<!--  -->
<template>
    <div class="searchAp-ctn" id="memberStaffChoose">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">员工</div>
                    <div>
                        <el-select v-model="searchData.SId" filterable clearable remote size="small" placeholder="选择员工" style="width: 100%">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column show-overflow-tooltip width="120" prop="StaffName" label="员工"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="JobNum" label="工号"></el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="Department" label="部门"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150" prop="Position" label="职位"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150" prop="PhoneNum" label="电话"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150" prop="IsJoin" label="状态"></el-table-column>
                <el-table-column fixed="right" label="操作" width="85px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="加入联盟" size="mini" type="text" v-if="scope.row.IsJoin == '未加入'" @click="addToUnion(scope.row.StaffId)">加入联盟</el-button>
                        </div>
                    </template></el-table-column
                >
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {},
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                SId: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.getSIdList();
        this.getTableData();
        let dialogbody = document.querySelector('#memberStaffChoose');
        this.$util.setEventForDialog(this, dialogbody);
    },
    methods: {
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                SId: '',
                page: 1,
                limit: 10
            };
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetMemberStaffList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            }
        },
        addToUnion(staffId) {
            this.loading = true;
            if (staffId) {
                this.$util
                    .axiosPost({
                        url: '/api/EntpUnions/SubmitStaffAddToUnion',
                        data: {
                            UnionId: this.searchData.UnionId,
                            StaffId: staffId
                        }
                    })
                    .then(() => {
                        this.loading = false;
                        this.$util.successMsg('加入成功');
                        this.$emit('closeDialog', true);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else this.$util.warningMsg('请选择要加入的员工');
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    height: 600px;
    overflow-y: auto;
}
</style>
